export default "__VITE_ASSET__w8hlaVU1__"